import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import axiosOrganizationInstance from './AxiosOrganizationInstance';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/support.css';


const Support = () => {
    const [formData, setFormData] = useState({
        issueDateTime: '',
        issuePage: '',
        contactNumber: '',
        issueDetails: '',
        status: '', // status field
        type: '',   // dropdown for type
        files: [],
    });

    const [fileErrors, setFileErrors] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const newFiles = [...formData.files];
        let errors = false;

        selectedFiles.forEach(file => {
            if (file.size > 2 * 1024 * 1024) { // 2MB size limit
                errors = true;
                setFileErrors('Each file must be less than 2MB.');
                return;
            }
            newFiles.push(file);
        });

        if (!errors) {
            setFileErrors('');
            setFormData({
                ...formData,
                files: newFiles,
            });
        }
    };

    const removeFile = (fileToRemove) => {
        const updatedFiles = formData.files.filter(file => file.name !== fileToRemove.name);
        setFormData({
            ...formData,
            files: updatedFiles,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const data = new FormData();
        data.append('issue_date_time', formData.issueDateTime);
        data.append('contact_number', formData.contactNumber);
        data.append('status', formData.status);
        data.append('type', formData.type); // Send type as part of the FormData
        data.append('issue_page', formData.issuePage); // Optional
        data.append('issue_details', formData.issueDetails); // Optional

        formData.files.forEach(file => {
            data.append('file', file); // Ensure 'file' matches the server's expected field name
        });

        try {
            const token=localStorage.getItem('Token')
            const response = await axiosOrganizationInstance.post('http://localhost:5000/file', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`,
                },
            });
            console.log('Files uploaded successfully:', response.data);
            setFormData({
                issueDateTime: '',
                issuePage: '',
                contactNumber: '',
                issueDetails: '',
                status: '',
                type: '', // Reset type as well
                files: [],
            });
        } catch (error) {
            console.error('Error uploading files:', error.response.data);
        }
    };

    return (
        <Container className="support-modal" style={{marginTop:'20px'}}>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="issueDateTime">
                            <div style={{display:'flex',alignItems:'flex-start'}}>
                                <Form.Label>Issue Date & Time</Form.Label>
                            </div>
                            <Form.Control
                                type="datetime-local"
                                name="issueDateTime"
                                value={formData.issueDateTime}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="issuePage">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Issue Page</Form.Label>
                            </div>
                            <Form.Control
                                type="text"
                                name="issuePage"
                                value={formData.issuePage}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <Form.Group controlId="contactNumber">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Contact Number</Form.Label>
                            </div>
                            <Form.Control
                                type="tel"
                                name="contactNumber"
                                value={formData.contactNumber}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="issueDetails">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Issue Details</Form.Label>
                            </div>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="issueDetails"
                                value={formData.issueDetails}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="status">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Status</Form.Label>
                            </div>
                            <Form.Control
                                type="text"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="type">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Type</Form.Label>
                            </div>
                            <Form.Control
                                as="select"
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Type</option>
                                <option value="organization">organization</option>
                                <option value="customer">Customer</option>
                                <option value="restaurant">Restaurant</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="fileUpload">
                            <div style={{display:'flex',alignItems:'flex-start',marginTop:'10px'}}>
                                <Form.Label>Upload Files</Form.Label>
                            </div>
                            <Form.Control
                                type="file"
                                name="files"
                                multiple
                                onChange={handleFileChange}
                            />
                            {fileErrors && <div className="text-danger">{fileErrors}</div>}
                            <ul className="file-list">
                                {formData.files.map((file, index) => {
                                    const fileSize = (file.size / 1024).toFixed(2); // Size in KB
                                    return (
                                        <li key={index} className="file-item">
                                            <span className="file-name">{file.name} ({fileSize} KB)</span>
                                            <Button
                                                variant=""
                                                onClick={() => removeFile(file)}
                                                className="delete-icon"
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </Button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </Form.Group>
                    </Col>
                </Row>

                <button  type="submit"  className='button1'>
                    Submit
                </button>
            </Form>
        </Container>
    );
};

export default Support;
